import { createElement } from "/elements_functions/new_elements.js";

export function createZoomController(exploreFieldWrapper, exploreField) {
    const existingZoomController = exploreFieldWrapper.zoomController;
    
    if(existingZoomController!==null && existingZoomController!==undefined)
        return;

    const exploreZoomController = createElement('div', null, ['explore-zoom-controller']);

    const exploreZoomControllerCaption = createElement('p', null, ['explore-zoom-controller-caption']);
    exploreZoomControllerCaption.innerText = 'Scale';

    const exploreZoomControllerInputWrapper = createElement('div', null, ['explore-zoom-controller-input-wrapper']);

    const exploreZoomControllerInput = createElement('input', null, ['explore-zoom-controller-input']);
    exploreZoomControllerInput.type = 'range';

    const minZoomValue = exploreField.minZoomValue;
    const maxZoomValue = exploreField.maxZoomValue;
    exploreZoomControllerInput.min = minZoomValue;
    exploreZoomControllerInput.max = maxZoomValue;
    exploreZoomControllerInput.step = 0.01;
    exploreZoomControllerInput.value = 1;
    
    exploreZoomControllerInputWrapper.append(exploreZoomControllerInput);

    exploreZoomController.append(exploreZoomControllerCaption);
    exploreZoomController.append(exploreZoomControllerInputWrapper);

    exploreZoomControllerInput.addEventListener('input', () => {

        const oldScale = exploreField.zoomScale;

        const newScale = parseFloat(exploreZoomControllerInput.value);


        const oldLeft = exploreField.leftPos;
        const oldTop = exploreField.topPos;

        const offsetLeft = (oldLeft + exploreFieldWrapper.offsetWidth/2 - exploreField.offsetWidth/2*(1-oldScale))/oldScale;
        const offsetTop = (oldTop + exploreFieldWrapper.offsetHeight/2 - exploreField.offsetHeight/2*(1-oldScale))/oldScale;


        const newLeft = oldLeft - (offsetLeft-exploreField.offsetWidth/2)*(oldScale-newScale);
        const newTop = oldTop - (offsetTop-exploreField.offsetHeight/2)*(oldScale-newScale);

        exploreField.scaleExploreField(newScale);

        if(newScale>=minZoomValue && newScale<=maxZoomValue)
            exploreField.moveExploreFieldTo(newLeft, newTop);
    });

    exploreFieldWrapper.zoomController = exploreZoomControllerInput;
    exploreField.zoomController = exploreZoomControllerInput;

    exploreFieldWrapper.append(exploreZoomController);
}